import * as React from 'react';
import styles from './overlays.module.css';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from '@mui/material';
import ModalClose from '@/components/ModalClose';

export default function FormWrapper ({
    children,
    isActive,
    onClose,
    onSubmit,
    isError,
    onErrorDialogClose,
    errorMessage,
    isSubmitted,
    submittedDialogTitle,
    onSubmittedDialogClose,
    submittedChildren
}: Readonly<{
    children: React.ReactNode;
    isActive: boolean;
    onClose: () => void;
    onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
    isError: boolean;
    onErrorDialogClose: () => void;
    errorMessage: string;
    isSubmitted: boolean;
    submittedDialogTitle: string;
    onSubmittedDialogClose: () => void;
    submittedChildren: React.ReactNode;
}>) {

    return (
        <>
            {isActive ? (
                <>
                    <Dialog
                        disablePortal
                        className="applyFormModal"
                        open={isActive}
                        onClose={onClose}
                        slotProps={{
                            paper: {
                                component: 'form',
                                onSubmit: onSubmit
                            }
                        }}
                    >
                        {children}
                    </Dialog>
                    <Dialog
                        disablePortal
                        className="formErrorModal"
                        open={isError}
                        onClose={onErrorDialogClose}
                    >
                        <div className={styles.modalHeader}>
                            <DialogTitle className={styles.modalTitle}>
                                Error
                            </DialogTitle>
                            <ModalClose onClick={onErrorDialogClose} />
                        </div>
                        <DialogContent>
                            <DialogContentText className={styles.modalDescription}>
                                We encountered an error, see below:
                            </DialogContentText>
                            <DialogContentText>
                                <code className={styles.code}>{errorMessage}</code>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                id="error-dialog-close"
                                variant="contained"
                                onClick={onErrorDialogClose}
                            >
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        disablePortal
                        className="formSubmitModal"
                        open={isSubmitted}
                        onClose={onSubmittedDialogClose}
                    >
                        <div className={styles.modalHeader}>
                            <DialogTitle className={styles.modalTitle}>
                                {submittedDialogTitle}
                            </DialogTitle>
                            <ModalClose onClick={onSubmittedDialogClose} />
                        </div>
                        <DialogContent>
                            {submittedChildren}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                id="submitted-dialog-close"
                                variant="contained"
                                onClick={onSubmittedDialogClose}
                            >
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog>
                </>
            ) : (
                <></>
            )}
        </>
    );
}